<template>
  <div>
    <h1 v-if="false" class="text-center display-2 my-16 font-weight-bold">
      🚀 Apps
    </h1>
    <ProjectComponent
      class="my-16"
      :imgSrcs="[
        '/img/projects/habitus/habitus-1.png',
        '/img/projects/project-habitus-technology-andromeda-mario-novak.png',
        '/img/projects/habitus/habitus-2.png',
        '/img/projects/habitus/habitus-3.png',
      ]"
      :headerLink="{
        name: '🏄 Habitus - Gamified Emotions, Habit Tracker and Journal',
        href: 'https://gethabitus.com/',
      }"
      :tags="[
        'TypeScript',
        'Koa.js',
        'Vue.js',
        'Vuetify',
        'Progressive Web App',
      ]"
      :descriptions="[
        'State-of-the-art Tracker for emotions, habits and thoughts.',
      ]"
      :points="[
        `Track emotions`,
        `Track thoughts (journal)`,
        `Track habits (good or bad)`,
        `Sound notifications`,
        `Performance graphs`,
        `Open source`,
        `Anonymous`,
        `Storing data only in your browser`,
      ]"
      :links="[
        {
          name: 'Open the App',
          href: 'https://gethabitus.com/',
        },
        {
          name: 'GitHub: Frontend',
          href: 'https://github.com/AndromedaTechnology/habitus',
        },
        {
          name: 'GitHub: API',
          href: 'https://github.com/AndromedaTechnology/habitus-api',
        },
        {
          name: 'Twitter: Page',
          href: 'https://twitter.com/HabitusToday',
        },
        {
          name: 'Medium: Page',
          href: 'https://medium.com/@habitus.today',
        },
      ]"
    ></ProjectComponent>
    <ProjectComponent
      class="my-16"
      :imgSrcs="[
        '/img/projects/onetius-1.jpg',
        '/img/projects/project-onetius-technology-andromeda-mario-novak.jpg',
      ]"
      :headerLink="{
        name: '👨🏻‍🏫 Onetius - Slick and Powerful E-Learning Platform',
        href: 'https://onetius.com/',
      }"
      :tags="[
        'Product Development',
        'API Development - Laravel',
        'Frontend Development - backbone.js',
      ]"
      :descriptions="[
        `        Learn from others or start your own Courses with your friends or colleagues. <br>
        Create Teams to host closed-down Courses for your Company, Family or Friends.`,
        `<strong>4900+ Teachers and Students.</strong>`,
      ]"
      :points="[
        `Open - Anyone can start or follow a course`,
        `Unbounded lessons - text, audio, video, photos`,
        `Test your knowledge - MicroExams after each lesson`,
        `Compare your performance with others - PerformanceGraph`,
        `Community discussions`,
        `Collaborations - People Nearby`,
        `Teams - Public, Private Courses`,
      ]"
      :links="[
        {
          name: 'Medium: Showcase article',
          href: 'https://medium.com/andromeda-technology/onetius-a-decade-ahead-of-its-time-the-e-learning-platform-edbdaf9f6d6a',
        },
        {
          name: 'YouTube: Pitch [VIDEO]',
          href: 'https://www.youtube.com/watch?v=tEkkxMh8JxE',
        },
        {
          name: 'YouTube: Channel',
          href: 'https://www.youtube.com/user/Onetius',
        },
        {
          name: 'Facebook: Page',
          href: 'https://facebook.com/Onetius',
        },
        {
          name: 'Press 1: MojaRijeka.hr',
          href: 'https://www.mojarijeka.hr/onetius-znanje-dostupno-svima-kroz-novu-mreznu-platformu/',
        },
        {
          name: 'Press 2: Netokracija.com',
          href: 'https://www.netokracija.com/onetius-edukativna-platforma-mario-novak-113910',
        },
      ]"
    ></ProjectComponent>
    <ProjectComponent
      class="my-16"
      :imgSrcs="[
        '/img/projects/project-iron-heart-festival-technology-andromeda-mario-novak.jpg',
        '/img/projects/ihf-1.jpg',
      ]"
      :headerLink="{
        name: '💪 Iron Heart Festival - Sports Competition and Platform',
        href: 'https://ironheartfestival.com/',
      }"
      :tags="['Product Development', 'API Development - Laravel']"
      :descriptions="[
        `Sports Competition - Athletes compete for the title of <strong>'The most athletic individual on the Planet'</strong>.<br>
        Online Platform - educational videos, training logs of athletes.`,
        `<strong>7+ million views on YouTube.</strong><br>
        <strong>20k+ subscribers on YouTube.</strong>`,
      ]"
      :points="[
        `Perfect mix of disciplines`,
        `Benchmark your speed, strength, agility`,
        `Compete with others once a year - at IHF Finals in Croatia`,
        `Track your progress online - Arena - Digital playground`,
        `Academy - Workshops and Lectures - Online and Offline in Croatia`,
      ]"
      :links="[
        {
          name: 'Google Docs: Booklet',
          href: 'https://docs.google.com/presentation/d/1mtKZiaNoi20_M2644vOoVItaEpQhodYhrDc5C_AVmAI/edit?usp=sharing',
        },
        {
          name: 'YouTube: Aftermovie',
          href: 'https://www.youtube.com/watch?v=dELRiTYFX70',
        },
        {
          name: 'YouTube: Channel',
          href: 'https://www.youtube.com/user/heartrequired/videos?view=0&sort=p&flow=grid',
        },
        {
          name: 'Facebook: Page',
          href: 'https://facebook.com/ironheartfestival',
        },
        {
          name: 'Press: Jutarnji.hr',
          href: 'https://www.jutarnji.hr/Promo/najbrze-rastuci-sportski-festival-u-europi-pocinje-za-11-dana-u-hrvatskoj/6484561/',
        },
      ]"
    ></ProjectComponent>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import ProjectComponent from './ProjectComponent.vue';

export default defineComponent({
  name: 'StartupsComponent',
  components: {
    ProjectComponent,
  },
});
</script>
